import { Icon } from 'shared_DEPRECATED/components/Icon';

import { Tooltip } from 'shared/components/Tooltip';
import { Typography } from 'shared/components/Typography';

export type TChallengeInfoPrivacyProps = {
  isPrivate?: boolean;
};

export const ChallengeInfoPrivacy = ({
  isPrivate = false,
}: TChallengeInfoPrivacyProps) =>
  isPrivate ? (
    <Tooltip
      content={
        <Typography color="white" fontWeight="medium" type="small">
          This challenge is private
        </Typography>
      }
      positioning={{ offset: 8, placement: 'top' }}
    >
      <Icon name="visibility" width="12px" height="12px" />
    </Tooltip>
  ) : null;
